import * as React from 'react';
import { CalendarPrintPage } from '../CalendarPrintPage';
import { CalendarPrintWeekLayoutPage } from '../CalendarPrintWeekLayoutPage';
import { CalendarPrintView } from '../CalendarPrintView';
import {
    CalendarViewPageProps,
    CalendarViewPageStyleProps,
    CalendarViewPageStyles,
} from './CalendarViewPage.types';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { WeekLayout } from '../PrintSettings';
import { DateRangeType } from 'owa-calendarview-settings';

const getClassNames = classNamesFunction<CalendarViewPageStyleProps, CalendarViewPageStyles>();

let cssStyles = require('./CalendarViewPage.scss');
let bindClassNames = require('classnames/bind').bind(cssStyles);

/** The base non-styled version of CalendarViewPage. */
export function CalendarViewPageBase<TEvent>(props: CalendarViewPageProps<TEvent>) {
    const { styles, className, miniMonth } = props;
    const scaleWithMiniMonth = 0.54;
    const scaleWithoutMiniMonth = 0.64;

    const {
        title,
        calendarView,
        events,
        getSurfaceItemModel,
        getCalendarEventColorScheme,
        getCharm,
        calendarColorScheme,
        weekLayout,
        notes,
        isRTL,
    } = props;

    let calendarZoomValue = miniMonth ? scaleWithMiniMonth : scaleWithoutMiniMonth;

    const classNames = getClassNames(styles, {
        className: className,
        calendarZoom: calendarZoomValue,
        isRTL: isRTL,
    });

    const shouldShowLayoutView =
        (calendarView.view === DateRangeType.Week ||
            calendarView.view === DateRangeType.WorkWeek) &&
        weekLayout !== WeekLayout.Standard;
    let content = shouldShowLayoutView ? (
        <CalendarPrintWeekLayoutPage
            className={cssStyles.printPreview}
            calendarView={calendarView}
            weekLayout={weekLayout}
            events={events}
            getSurfaceItemModel={getSurfaceItemModel}
            getCalendarEventColorScheme={getCalendarEventColorScheme}
            getCharm={getCharm}
            isRTL={isRTL}
        />
    ) : (
        <CalendarPrintView
            className={bindClassNames(classNames.printView, cssStyles.printPreview)}
            calendarView={calendarView}
            events={events}
            getSurfaceItemModel={getSurfaceItemModel}
            getCalendarEventColorScheme={getCalendarEventColorScheme}
            getCharm={getCharm}
            isRTL={isRTL}
        />
    );

    return (
        <CalendarPrintPage
            className={classNames.root}
            contentCanGrow={false}
            title={title}
            calendarView={calendarView}
            calendarColorScheme={calendarColorScheme}
            notes={notes}
            miniMonth={miniMonth}>
            {content}
        </CalendarPrintPage>
    );
}
